/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1OfacFileState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_OFAC_FILE_STATE_ENTITY_NAME = 'ixf.watchlist.v1.OfacFile';
export const ixfWatchlistV1OfacFileStateEntity = new schema.Entity<IxfWatchlistV1OfacFileState>(IXF_WATCHLIST_V1_OFAC_FILE_STATE_ENTITY_NAME, {}, { idAttribute: 'ofacFileId' });

